module.exports = __webpack_public_path__ + "media/images/iconEdit__errorRed--dark-791d9220fe513643bce0f4d47320cc77.png";